import { render, staticRenderFns } from "./pcvideos.vue?vue&type=template&id=13115c99"
import script from "./pcvideos.vue?vue&type=script&lang=js"
export * from "./pcvideos.vue?vue&type=script&lang=js"
import style0 from "./pcvideos.vue?vue&type=style&index=0&id=13115c99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports